import { render, staticRenderFns } from "./ProductItemView.vue?vue&type=template&id=d3d06450&scoped=true&"
import script from "./ProductItemView.vue?vue&type=script&lang=js&"
export * from "./ProductItemView.vue?vue&type=script&lang=js&"
import style0 from "./ProductItemView.vue?vue&type=style&index=0&id=d3d06450&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3d06450",
  null
  
)

export default component.exports